import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("cz_token");
  // Only apply the admin token when the caller hasn't already set an Authorization
  // header (e.g. member endpoints pass their own member token via authHeaders()).
  if (token && !config.headers.Authorization) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Surface a clear, professional message for permission (403) failures so that
// view-only users see why an action was blocked instead of a generic error.
const PERMISSION_MESSAGE = "You don't have permission to do this. Please contact your administrator for access.";
api.interceptors.response.use(
  (res) => res,
  (error) => {
    if (error.response?.status === 403) {
      if (!error.response.data || typeof error.response.data !== "object") error.response.data = {};
      error.response.data.detail = PERMISSION_MESSAGE;
    }
    return Promise.reject(error);
  }
);

export { API };
export default api;
